import { semesterAndYearOptions } from "keys/years"
import { useContext, useMemo } from "react"
import { semesters } from "keys"
import { AutoComplete } from "components/Form"
import { SelectAssessmentsContext } from "../CreateAssessments"

const useSemesterAndYearFilters = () => {
    const { setSemester, semester, year, setYear } = useContext(SelectAssessmentsContext)

    const semesterAndYearFilters = useMemo(() => [
        {
            name: "school_year",
            options: semesterAndYearOptions,
            component: AutoComplete,
            size: "small",
            input: {
                value: year,
                onChange: setYear
            },
            fullWidth: true,
            disabled: true, // כרגע אנחנו מאפשרים יצירת מבדק אך ורק לשנת לימודים הנכחית
            placeholder: "בחר שנת לימודים"
        },
        {
            name: "semester",
            size: "small",
            options: semesters,
            component: AutoComplete,
            input: {
                value: semester,
                onChange: setSemester
            },
            placeholder: "בחר סמסטר",
            fullWidth: true
        },
    ], [semester, year])

    return semesterAndYearFilters
}

export default useSemesterAndYearFilters